import React from "react";
import {Button, Row, Typography, Skeleton, Space} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import "./catalog.product.list.scss";
import {Pagination} from "../../../../models/requests/paginated-result/paginated.result";
import {PaginatedRequest} from "../../../../models/requests/paginated-request/paginated.request";
import {DownloadResult} from "../../download-result/download-result";

interface CatalogProductListProps {
    loading: boolean;
    onViewChange: (view: "cards" | "table") => void;
    pagination?: Pagination;
    request: PaginatedRequest | null;
}

export const CatalogProductList: React.FC<CatalogProductListProps> = ({loading, onViewChange, pagination, request}) => {

    return (
        <Space direction={"horizontal"} className="catalog_view_panel" style={{justifyContent: 'space-between'}}>
            {loading ? (
                <Skeleton.Button active style={{marginLeft: 10, height: 30}}/>
            ) : (
                <Space direction={"horizontal"}>
                    <Typography.Text className="catalog_view_panel_count">
                        {pagination ? (
                            <>{(pagination.limit * pagination.page) - pagination.limit + 1}-{pagination.limit * pagination.page} / {pagination.total}</>
                        ) : null}
                    </Typography.Text>
                    {request && pagination && pagination.totalPages > 0 ? (
                        <DownloadResult request={request} />
                    ) : null}
                </Space>
            )}
            <Space direction={"horizontal"}>
                <Button
                    onClick={() => onViewChange("cards")}
                    className="catalog_view_panel_button ws_button"
                    icon={<FontAwesomeIcon icon={["fas", "list"]} size={"lg"}/>}
                    style={{marginLeft: "auto"}}
                />
                <Button
                    onClick={() => onViewChange("table")}
                    className="catalog_view_panel_button ws_button"
                    icon={<FontAwesomeIcon icon={["fas", "bars"]} size={"lg"}/>}
                />
            </Space>
        </Space>
    );
}
